export const authToken = localStorage.getItem("Token");
export const isAuth = authToken ? true : false;